import APIController from '../core-api-controller';

export const fetchSupportTemplatesApi = ({ paramsObj = {}, paramsStr = '' } = {}) => {
  const path = `${APIController.endpointApi}/support_templates${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const createSupportTemplateApi = (data = {}) => {
  const path = `${APIController.endpointApi}/support_templates`;
  return APIController.postCallback(path, data);
};

export const updateSupportTemplateApi = (id, data = {}) => {
  const path = `${APIController.endpointApi}/support_templates/${id}`;
  return APIController.putCallback(path, data);
};

export const deleteSupportTemplateApi = (id = '') => {
  const path = `${APIController.endpointApi}/support_templates/${id}`;
  return APIController.deleteCallback(path);
};

export const renderBodySupportTemplateApi = (id = '', patientId = '') => {
  const path = `${APIController.endpointApi}/support_templates/${id}/render_body?patient_id=${patientId}`;
  return APIController.getApiCallback(path);
};
